import {
  AktEuDetail,
  AktEuDetailExternalApi,
  LegislativnyMaterial as LegislativnyMaterialGenerated,
  PrilohaAktEu as PrilohaAktEuGenerated,
} from 'sprava-aktov-eu-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { spravaAktovEuPrefixPath } from '../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import NavrhAktuEu from '../../model/NavrhAktuEu';
import LegislativnyMaterial from '../../model/LegislativnyMaterial';
import PrilohaAktEu from '../../model/PrilohaAktEu';

const client = new AktEuDetailExternalApi(apiConfiguration(spravaAktovEuPrefixPath));

const mapLegislativnyMaterial = (data: LegislativnyMaterialGenerated): LegislativnyMaterial => ({
  uuid: data.uuid,
  cisloLegMaterialu: data.cisloLegMaterialu,
  name: data.name,
  redirectUrl: `/elegislativa/legislativne-procesy/SK/${data.cisloLegMaterialu}`,
});

const mapPrilohaAktEu = (data: PrilohaAktEuGenerated): PrilohaAktEu => ({
  uuid: data.uuid,
  fileName: data.fileName,
  fileFormat: data.fileFormat,
  name: data.name,
  jazyk: data.jazyk,
  datumPublikacie: data.datumPublikacie ? new Date(data.datumPublikacie) : undefined,
  typDokumentuAktEu: data.typDokumentuAktEu,
  fileSize: data.fileSize,
});

const map = (data: AktEuDetail): NavrhAktuEu => ({
  uuid: data.uuid,
  aktId: data.aktId,
  medziinstitucionalnyKod: data.medziinstitucionalnyKod,
  name: data.name,
  datumPrijatiaAktu: data.datumPrijatiaAktu ? new Date(data.datumPrijatiaAktu) : undefined,
  institucia: data.institucia,
  typ: data.typ,
  stupenUtajenia: data.stupenUtajenia,
  legislativnyMaterial: data.legislativnyMaterial ? mapLegislativnyMaterial(data.legislativnyMaterial) : undefined,
  prilohaAktEuList: data.prilohaAktEuList ? data.prilohaAktEuList.map(priloha => mapPrilohaAktEu(priloha)) : [],
});

// eslint-disable-next-line import/prefer-default-export
export const fetchNavrhAktuEuDetail = async (
  uuid: Uuid,
):
  Promise<ClientResponse<NavrhAktuEu>> => {
  const {
    data,
    status,
  } = await client.getAktEuDetail(
    uuid,
  );
  return {
    data: map(data),
    responseCode: status,
  };
};
